<template>
    <div class="container" style="max-width: 532px !important;">
        <div class="magicAiLogin">
            <h2>Welcome Back</h2>
            <h3>Please Enter Your Details</h3>
            <form @submit.prevent="request_password()" v-show="forgot_pass">
                
                

                <input
  placeholder="Email Address"
  type="text"
  class="form-control"
  v-model="form1.email"
  v-validate="'required|email'"
  name="email"
  :class="{ 'is-invalid': verrors.has('form1.email') }"
  data-vv-scope="form1"
/>
<p v-if="verrors.has('form1.email')" class="errormsg">{{ verrors.first('form1.email') }}</p>


                
                <button class="forgot_pass" type="button" @click="forgot_pass=false"> < Back to Login </button>
                <div class="buttonSec">
                    <button type="submit">Request Password</button>
                    <router-link to="/design-ai/singup">Don't have an account? <span>Sign-Up</span></router-link>
                </div>
            </form>
            <form @submit.prevent="ai_login()" v-show="!forgot_pass">
                <input placeholder="Email Address" type="text" class="form-control" v-model="form.email" v-validate="'required|email'" name="email" :class="{ 'is-invalid': verrors.has('email') }" data-vv-scope="form2">
                <p v-if="verrors.has('form2.email')" class="errormsg">{{ verrors.first('form2.email') }} </p>
                 
                <input placeholder="Password" name="password" type="password" class="form-control" v-model="form.password" v-validate="'required'" data-vv-scope="form2">
                <p v-if="verrors.has('form2.password')" class="errormsg">{{ verrors.first('form2.password') }} </p>
                <button class="forgot_pass" type="button" @click="forgot_pass=true">Forgot Password? </button>
                <div class="buttonSec">
                    <button type="submit">Log In</button>
                    <router-link to="/design-ai/singup">Don't have an account? <span>Sign-Up</span></router-link>
                </div>
            </form>
            
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import axios from "axios";  
export default {  
    name:'Login',
    data() {
        return {
            forgot_pass:false,
            form:{
                email:'',
                password:''
            },
            form1:{
                email:'', 
            }
        };
    },
    watch: {
        Aiuser: {
             handler: function (newValue) {
                 if (newValue) {
                     if (this.Aiuser) { 
                             this.$router.push("/design-ai").catch(() => {}); 
                     }
                 }
             },
             deep: true
         }
     },
    computed: {
        ...mapGetters("auth", ["user"]),
        ...mapGetters("Aiauth", ["Aiuser"]),
        ...mapGetters("Common", ["Setting"]),
        ...mapGetters({ 
            showroomId: "Common/MyItem", 
        }),
        ...mapGetters(["errors"]),
    },
    methods: {
        ...mapActions("Aiauth", ["sendLoginRequest" ]),
        async ai_login(){
            this.$validator.validateAll('form2').then(async (valid) => {
                if (valid) { 
                    let loader = this.$loading.show({ loader: 'dots' })  
                    this.form.fAction="login";
                    this.form.shop_id = this.showroomId.showroom 

                        this.sendLoginRequest(this.form).then(() => {
                            loader.hide()
                            if(this.Aiuser){
                            this.$router.push('/design-ai');
                                if (data.data.success) {
                                    this.form = {};
                                }
                            }
                            Toast.fire({
                                icon: 'success',
                                title: data.data.message
                            });

                        })  
                        .catch(err => {
                            loader.hide()
                        })

                }
            })
        },
        
        async request_password(){
            this.$validator.validateAll('form1').then(async (valid) => {
                if (valid) { 
                    let loader = this.$loading.show({ loader: 'dots' })  
                    this.form1.fAction="forget_password";
                    this.form1.shop_id = this.showroomId.showroom 

                    axios.post('/api/AI/design', this.form1)
                    .then((data) => {
                        loader.hide()
                        if (data.data.success) { 
                            this.forgot_pass=false
                            Toast.fire({
                                icon: 'success',
                                title: data.data.message
                            });
                        } else{
                            Toast.fire({
                                icon: 'error',
                                title: data.data.message
                            });
                        }
                    })
                    .catch(err => {
                        loader.hide()
                    })

                }
            })
        },
    },
    created(){
        if(this.Aiuser){
            this.$router.push('/design-ai');
        }
    },

    mounted() { 
         this.$store.commit("setErrors", {});
         if (this.Aiuser) {
            this.$router.push('/design-ai');
         }

     },

    
};

</script>
 